/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../components/baseclasses/guid.ts" />
/// <reference path="../../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.MemberBenefitTemplates {
    "use strict";
    import IMemberBenefitTemplateDiscountItem = Meevo.Model.MemberBenefitTemplateDiscountItem;

    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.MemberBenefitTemplate> {
        exceptionServiceOverrideList = [];
        public decimalMask = 0;
        public serviceOverrideCriteria = { wildCardType: 2, excludeIdList: [] };
        public productOverrideCriteria = {
            wildCardType: 2,
            excludeIdList: [],
            includeBundles: true
        };
        public packageOverrideCriteria = { coSearchResultFilter: 0, excludeIdList: [] };

        createSectionModelInstance(postAdd: (data: any) => any): void {
            let self = this;

            this.dataService.getTemplate(this.baseEndpoint)
                .then((data) => {
                    this.model = data;

                    this.addRowOverride(this.model.serviceListDiscounts);
                    this.addRowOverride(this.model.productListDiscounts);
                    this.addRowOverride(this.model.packageListDiscounts);
                });
        }


        /**
         * Click add Service Price for add row inputs
         * @param arr - array in which push row for overrayde
         * */
        public addRowOverride(arr: Array<Object>): void {
            let overridesRowModel: IMemberBenefitTemplateDiscountItem = {
                membershipBenefitTemplateId: '',
                id: '',
                displayName: '',
                discountAmount: 0,
                isPercent: true,
                sku: '',
                variantDisplayName: '',
                shortCut: ''
            };

            arr.push(overridesRowModel);
            this.excludeIdList();
        }

        /**
         * Select item for override
         * @param item - item row override
         * @param type - not required, type for displayName
         */
        public changeOverrideItem(item: IMemberBenefitTemplateDiscountItem, type?: string): void {
            if (item['overrideModel'].id) {
                item.id = item['overrideModel'].id;
                item.displayName = item['overrideModel'].displayName;

                switch (type) {
                    case 'product':
                        item.sku = item['overrideModel'].sku;
                        item.variantDisplayName = item['overrideModel'].variantDisplayName;
                        break;
                    case 'service':
                        item.shortCut = item['overrideModel'].shortcut;
                        break;
                }
            }
        }

        /**
         * Change switch percent or currency
         * @param item - item row override
         */
        public isPercentChanged(item: IMemberBenefitTemplateDiscountItem):void {
            if (item.isPercent === true && item.discountAmount > 100) {
                item.discountAmount = 0;
            }
        }

        /**
         * Click remove icon
         * Remove item from Discounts
         * @param item - item row override for delete
         * @param arr - list items
         * */
        public removeRow(item: IMemberBenefitTemplateDiscountItem, arr: Array<Object>): void {
            let index = arr.indexOf(item);
            arr.splice(index, 1);
            this.excludeIdList();
        }

        /**
         * Pre Process list Services for remove prev override item
         * @param responseData
         * @param requestData
         */
        public preProcessServiceOverrideItems(responseData, requestData): any {
            let discountList = this.model.serviceListDiscounts;

            // filter 
            if (discountList.length > 1) {
                let filtered: Array<Object> = _.reject(responseData, function (itemService: any): any {
                    return _.find(discountList, function (item: any) {
                        return item.id === itemService.id
                    })
                });

                // Change original array. Because responseData = filtered; don't change original variable
                responseData.length = 0;
                responseData.push.apply(responseData, filtered);
            }

            return responseData;
        }

        /**
         * Pre Process list Product for remove prev override item
         * @param responseData
         * @param requestData
         */
        public preProcessProductOverrideItems(responseData, requestData): any {
            let discountList = this.model.productListDiscounts;

            // filter 
            if (discountList.length > 1) {
                let filtered: Array<Object> = _.reject(responseData, function (itemService: any): any {
                    return _.find(discountList, function (item: any) {
                        return item.id === itemService.id
                    })
                });

                // Change original array. Because responseData = filtered; don't change original variable
                responseData.length = 0;
                responseData.push.apply(responseData, filtered);
            }

            return responseData;
        }

        /**
         * Pre Process list package for remove prev override item
         * @param responseData
         * @param requestData
         */
        public preProcessPackageOverrideItems(responseData, requestData): any {
            let discountList = this.model.packageListDiscounts;

            // filter 
            if (discountList.length > 1) {
                let filtered: Array<Object> = _.reject(responseData, function (itemService: any): any {
                    return _.find(discountList, function (item: any) {
                        return item.id === itemService.id;
                    })
                });

                // Change original array. Because responseData = filtered; don't change original variable
                responseData.length = 0;
                responseData.push.apply(responseData, filtered);
            }

            return responseData;
        }

        public excludeIdList() {
            this.serviceOverrideCriteria.excludeIdList = this.model.serviceListDiscounts.map(function (item) {
                if (item.id && item.id !== '') {
                    return item.id;
                }
            });
            this.productOverrideCriteria.excludeIdList = this.model.productListDiscounts.map(function (item) {
                if (item.id && item.id !== '') {
                    return item.id;
                }
            });
            this.packageOverrideCriteria.excludeIdList = this.model.packageListDiscounts.map(function (item) {
                if (item.id && item.id !== '') {
                    return item.id;
                }
            });
        }

        public preSave(): void {

            // remove empty rows
            this.model.serviceListDiscounts = _.filter(this.model.serviceListDiscounts, function (item: IMemberBenefitTemplateDiscountItem) {
                delete item['overrideModel'];
                return item.id !== '';
            });
            this.model.productListDiscounts = _.filter(this.model.productListDiscounts, function (item: IMemberBenefitTemplateDiscountItem) {
                delete item['overrideModel'];
                return item.id !== '';
            });
            this.model.packageListDiscounts = _.filter(this.model.packageListDiscounts, function (item: IMemberBenefitTemplateDiscountItem) {
                delete item['overrideModel'];
                return item.id !== '';
            });
        }
    }
}